// extracted by mini-css-extract-plugin
export default {"container":"deducao_container__+pRuF","divider":"deducao_divider__NYDiB","inputDeducao":"deducao_inputDeducao__nJRJQ","label":"deducao_label__DguXC"};